import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import { getCurrentInstance, reactive, ref, computed, onActivated } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store/index'
import Pagination from '@/components/Pagination.vue'
import { getCouponPackageListApi, genCouponApi, getCouponCheckStatusApi, getCouponTransferStatusApi, transferApi } from '@/apis/marketing'
import { CouponType } from './enum'
import { openRouteInNewWindow } from '@/utils/router-helper'
import { downloadFile } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'CouponPackageList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()
const store = useStore()

const roleId = store.state.user.userInfo.group_id.split(',')
const userId = Number(store.state.user.userInfo.id)

// 是否可以搜索自制电子券
// const canSearchCoupon = computed(() => [6078,7104,8129].includes(userId))

const filters = reactive({
  name: '',
  coupon_id: '',
  memo: '',
  type: '',
  status: '',
  sale_channel: '',
  created_at: '',
  amount: '',
  page: 1,
  page_size: 10
})

const tableData = ref([])
const total = ref(0)
const getList = async () => {
    const { code, data, msg } = await getCouponPackageListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    tableData.value = data.data
    total.value = data.total
}

const onPageChange = (val: number) => {
  filters.page = val
  getList()
}

const onSizeChange = (val: number) => {
  filters.page_size = val
  getList()
}

// 处理查询
const onSearch = () => {
  filters.page = 1
  getList()
}

// 处理导出
const onExport = () => {
  downloadFile('/opsapi/couponExport', filters)
}

// 自制券码核销状态查询
const coupon_no = ref('')
const checkResult = ref('')
const getCouponCheckStatus = async () => {
  checkResult.value = ''
  if (!coupon_no.value) {
    proxy.$message({ type: 'warning', message: '请输入券码' })
    return
  }
  const { code, data, msg } = await getCouponCheckStatusApi(coupon_no.value) as any
  if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
  checkResult.value = msg
}

// 生成礼券
const onGenCoupon = async (row: any) => {
  const { code, data, msg } = await genCouponApi(row.id) as any
  if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
  proxy.$message({ type: 'success', message: '生成成功' })
  getList()
}

/*************************************** 处理调拨入总库 -- begin ***************************************/
const storeDialog = ref(false)
const storeForm = ref({
  coupon_id: '',
  ds_coupon_id: 0,
  num: 0,
  note: '',
  coupon_name: '',
  stock: 0,
})
const getCouponTransferStatus = async (row: any) => {
  const { id, left_cnt } = row
  const { code, data, msg } = await getCouponTransferStatusApi(id) as any
  if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

  if (data.data.length) {
    const coupon = data.data[0]
    storeForm.value.coupon_id = coupon.id
    storeForm.value.coupon_name = coupon.name
    storeForm.value.ds_coupon_id = id
    storeForm.value.stock = left_cnt
    storeDialog.value = true
  } else {
    proxy.$message({ type: 'warning', message: '当前券包未关联总库券包，请关联后再进行调拨~' })
    return
  }
}
// 保存调拨入库
const onSaveStore = async () => {
  if (!storeForm.value.coupon_id) {
    proxy.$message({ type: 'warning', message: '请选择券包' })
    return
  }
  
  if (!storeForm.value.num) {
    proxy.$message({ type: 'warning', message: '请输入有效数量' })
    return
  }
  
  if (storeForm.value.num > storeForm.value.stock) {
    proxy.$message({ type: 'warning', message: '当前线上库存不足' })
    return
  }
  
  const { code, data, msg } = await transferApi(storeForm.value) as any
  if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
  proxy.$message({ type: 'success', message: '调拨成功' })
  storeDialog.value = false
  getList()
}
const beforeStoreDialogClose = () => {
  storeForm.value = {
    coupon_id: '',
    ds_coupon_id: 0,
    num: 1,
    note: '',
    coupon_name: '',
    stock: 0,
  }
  storeDialog.value = false
}
/*************************************** 处理调拨入总库 -- end ***************************************/

/*************************************** 查询券详情 -- begin ***************************************/
const couponNumber = ref('')
const couponId = ref('')
const toCouponDetail = () => {
  if (!couponNumber.value && !couponId.value) {
    return proxy.$message({ type: 'warning', message: '请输入券码或券ID' })
  }

  openRouteInNewWindow({
    path: '/marketing/coupon-list',
    query: {
      coupon_no: couponNumber.value,
      user_coupon_id: couponId.value,
    }
  })
}
/*************************************** 查询券详情 -- end ***************************************/
onActivated(() => {
  getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "礼券名称",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.amount,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.amount) = $event)),
        modelModifiers: { trim: true },
        placeholder: "面值",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.created_at,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.created_at) = $event)),
        type: "date",
        placeholder: "创建时间",
        format: "YYYY-MM-DD",
        "value-format": "YYYY-MM-DD",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.type,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.type) = $event)),
        placeholder: "类型",
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: ""
          }),
          _createVNode(_component_el_option, {
            label: "门店券",
            value: "1"
          }),
          _createVNode(_component_el_option, {
            label: "优惠券",
            value: "2"
          }),
          _createVNode(_component_el_option, {
            label: "充值卡",
            value: "3"
          }),
          _createVNode(_component_el_option, {
            label: "组合券",
            value: "4"
          }),
          _createVNode(_component_el_option, {
            label: "随心兑自制",
            value: "10"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.status) = $event)),
        placeholder: "状态",
        clearable: "",
        filterable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "全部",
            value: ""
          }),
          _createVNode(_component_el_option, {
            label: "下架",
            value: "0"
          }),
          _createVNode(_component_el_option, {
            label: "上架",
            value: "1"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.sale_channel,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.sale_channel) = $event)),
        modelModifiers: { trim: true },
        placeholder: "销售渠道",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.coupon_id,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.coupon_id) = $event)),
        modelModifiers: { trim: true },
        placeholder: "券包id",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.memo,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.memo) = $event)),
        modelModifiers: { trim: true },
        placeholder: "备注信息",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: onSearch
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      (!_unref(roleId).includes('75'))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(router).push('/marketing/coupon-package-edit')))
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode("添加")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "ID",
          width: "70"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "名称",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "类型",
          width: "75"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(CouponType)[row.type]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "amount",
          label: "面值金额",
          width: "75"
        }),
        _createVNode(_component_el_table_column, {
          prop: "market_price",
          label: "市场价",
          width: "70"
        }),
        _createVNode(_component_el_table_column, {
          prop: "price",
          label: "售价",
          width: "70"
        }),
        _createVNode(_component_el_table_column, {
          prop: "left_cnt",
          label: "线上库存",
          width: "75"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          width: "50"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(row.status === 0 ? '下架' : '上架'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "创建时间",
          width: "140"
        }),
        _createVNode(_component_el_table_column, {
          prop: "memo",
          label: "备注",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "230"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_3, [
              (_unref(roleId).includes('75'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "small",
                    link: "",
                    onClick: ($event: any) => (_unref(router).push(`/marketing/coupon-package-edit?id=${row.id}&is_show=1`))
                  }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode("查看")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (!_unref(roleId).includes('75'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "primary",
                    size: "small",
                    link: "",
                    onClick: ($event: any) => (_unref(router).push(`/marketing/coupon-package-edit?id=${row.id}`))
                  }, {
                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                      _createTextVNode("编辑")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              ((_unref(CouponType)[row.type] == '门店券' || _unref(CouponType)[row.type] == '优惠券' || _unref(CouponType)[row.type] == '组合券') && row.gen_status > 0 && ((_unref(roleId).includes('1') || _unref(roleId).includes('56') || _unref(roleId).includes('77')) && row.is_test != 3 || ([10144].includes(_unref(userId)) && row.is_test == 1)))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    type: "primary",
                    size: "small",
                    link: "",
                    onClick: ($event: any) => (_unref(router).push(`/marketing/coupon-list?coupon_id=${row.id}`))
                  }, {
                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                      _createTextVNode(" 查看礼券 ")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              ((_unref(CouponType)[row.type] == '门店券' || _unref(CouponType)[row.type] == '优惠券' || _unref(CouponType)[row.type] == '组合券') && (_unref(roleId).includes('1') || _unref(roleId).includes('56') || ([10144].includes(_unref(userId)) && row.is_test == 1) || _unref(roleId).includes('77')))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 3,
                    disabled: row.gen_status >= row.count,
                    title: row.gen_status >= row.count ? '已生成' : '',
                    type: "primary",
                    size: "small",
                    link: "",
                    onClick: ($event: any) => (onGenCoupon(row))
                  }, {
                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                      _createTextVNode(" 生成礼券 ")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "title", "onClick"]))
                : _createCommentVNode("", true),
              (!_unref(roleId).includes('75'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 4,
                    type: "primary",
                    size: "small",
                    link: "",
                    onClick: ($event: any) => (_unref(router).push(`/marketing/coupon-package-edit?id=${row.id}&is_clone=1`))
                  }, {
                    default: _withCtx(() => _cache[22] || (_cache[22] = [
                      _createTextVNode("复制")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (!_unref(roleId).includes('75'))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 5,
                    type: "primary",
                    size: "small",
                    link: "",
                    disabled: !row.coupon_status,
                    title: !row.coupon_status ? '该券包非自制，不支持调拨入库~' : '',
                    onClick: ($event: any) => (getCouponTransferStatus(row))
                  }, {
                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                      _createTextVNode(" 调拨入总库 ")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "title", "onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      total: total.value,
      currentPage: filters.page,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["total", "currentPage"]),
    _createVNode(_component_el_form, {
      class: "mt20",
      inline: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "券号" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: couponNumber.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((couponNumber).value = $event)),
              placeholder: "请输入券号"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "券ID" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: couponId.value,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((couponId).value = $event)),
              placeholder: "请输入券号"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: toCouponDetail
            }, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [
                _createTextVNode("查询")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: storeDialog.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((storeDialog).value = $event)),
      title: "调入总库",
      width: "600px",
      "before-close": beforeStoreDialogClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: beforeStoreDialogClose }, {
          default: _withCtx(() => _cache[25] || (_cache[25] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onSaveStore
        }, {
          default: _withCtx(() => _cache[26] || (_cache[26] = [
            _createTextVNode("入库")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: storeForm.value,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "总库券包" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: storeForm.value.coupon_name,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((storeForm.value.coupon_name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "线上库存" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: storeForm.value.stock,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((storeForm.value.stock) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "调拨数量" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: storeForm.value.num,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((storeForm.value.num) = $event)),
                  min: 1,
                  max: storeForm.value.stock
                }, null, 8, ["modelValue", "max"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: storeForm.value.note,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((storeForm.value.note) = $event)),
                  type: "textarea",
                  rows: 3
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})